import { createContext, use } from 'react'

// How things inside the chat open the panel behind a turn (its changes or its
// trace), and which turn they belong to — e.g. an embed whose thing changed
// since opens that turn's change view focused on it.

export type OpenTurnPanel = (turnId: string, tab: 'changes' | 'trace', refs?: string[]) => void

export const OpenTurnPanelContext = createContext<OpenTurnPanel | null>(null)
export const TurnIdContext = createContext<string | null>(null)

export function useOpenTurnPanel(): OpenTurnPanel | null {
  return use(OpenTurnPanelContext)
}

export function useTurnId(): string | null {
  return use(TurnIdContext)
}
